const ReportsFilterValue = [
  { name: 'agency', operator: 'contains', type: 'string', value: '' },
  { name: 'totalPO', operator: 'gte', type: 'number', value: '' },
  { name: 'totalRfqReceived', operator: 'gte', type: 'number', value: '' },
  { name: 'totalRfqResponses', operator: 'gte', type: 'number', value: '' },
  { name: 'totalPoCost', operator: 'gte', type: 'number', value: '' },
  { name: 'totalRfqCost', operator: 'gte', type: 'number', value: '' },
  { name: 'projMargin', operator: 'gte', type: 'number', value: '' },
  { name: 'totalFinalPoCost', operator: 'gte', type: 'number', value: '' },
  { name: 'actualMargin', operator: 'gte', type: 'number', value: '' },
  { name: 'taxes', operator: 'gte', type: 'number', value: '' },
  { name: 'profit', operator: 'gte', type: 'number', value: '' },
  { name: 'months', operator: 'gte', type: 'number', value: '' },
  { name: 'vpoInvoices', operator: 'gte', type: 'number', value: '' },
  { name: 'totalSpoInvoices', operator: 'gte', type: 'number', value: '' },
  { name: 'buyingPrice', operator: 'gte', type: 'number', value: '' },
];

export const ItemsFilterValue = [
  { name: 'itemName', operator: 'contains', type: 'string', value: '' },
  { name: 'qty', operator: 'gte', type: 'number', value: '' },
  { name: 'totalPoCost', operator: 'gte', type: 'number', value: '' },
  { name: 'totalFinalPoCost', operator: 'gte', type: 'number', value: '' },
  { name: 'margin', operator: 'gte', type: 'number', value: '' },
  { name: 'profit', operator: 'gte', type: 'number', value: '' },
];

export const TotalsFilterValue = [
  { name: 'agency', operator: 'contains', type: 'string', value: '' },
  { name: 'totalPO', operator: 'gte', type: 'number', value: '' },
  { name: 'totalRfqReceived', operator: 'gte', type: 'number', value: '' },
  { name: 'totalRfqResponses', operator: 'gte', type: 'number', value: '' },
  { name: 'totalPoCost', operator: 'gte', type: 'number', value: '' },
  { name: 'totalRfqCost', operator: 'gte', type: 'number', value: '' },
  { name: 'projMargin', operator: 'gte', type: 'number', value: '' },
  { name: 'totalFinalPoCost', operator: 'gte', type: 'number', value: '' },
  { name: 'actualMargin', operator: 'gte', type: 'number', value: '' },
  { name: 'taxes', operator: 'gte', type: 'number', value: '' },
  { name: 'profit', operator: 'gte', type: 'number', value: '' },
  { name: 'months', operator: 'gte', type: 'number', value: '' },
  { name: 'vpoInvoices', operator: 'gte', type: 'number', value: '' },
  { name: 'totalSpoInvoices', operator: 'gte', type: 'number', value: '' },
];

export const ItemsTotalFilterValue = [
  { name: 'itemName', operator: 'contains', type: 'string', value: '' },
  { name: 'qty', operator: 'gte', type: 'number', value: '' },
  { name: 'totalPoCost', operator: 'gte', type: 'number', value: '' },
  { name: 'totalFinalPoCost', operator: 'gte', type: 'number', value: '' },
  { name: 'margin', operator: 'gte', type: 'number', value: '' },
  { name: 'profit', operator: 'gte', type: 'number', value: '' },
];

export default ReportsFilterValue;
